import { qsa } from "@fluorescent/dom";
import { intersectionWatcher, delayOffset } from "@/lib/animation";

const selectors = {
  header: ".animation--container-header > *",
  itemContainers: ".tabbed-collections__products:not(.animation-added)",
  items: ".animation--item",
};

export default node => {
  const itemDelay = delayOffset(node, [selectors.header]);
  const itemContainers = qsa(selectors.itemContainers, node);

  itemContainers.forEach(container => {
    delayOffset(container, [selectors.items], itemDelay);
    container.classList.add("animation-added");
  });

  const observer = intersectionWatcher(node);

  return {
    destroy() {
      observer?.destroy();
    },
  };
};
